/**
 * Check if value is a regExp
 * @param {*} value
 * @returns {boolean}
 */
export default (value) => {
	return Object.prototype.toString.call(value) === '[object RegExp]';
};
